(function (module) {
    "use strict";
    module.filter('numberInMilions', ['$filter', function ($filter: ng.IFilterService) {
        return function (input: $TSFixMe, showInMilions: $TSFixMe, decimals: $TSFixMe) {
            if (input == null)
                return '';

            if (showInMilions) {
                const result = (input / 1000000.0).toFixed(2);
                return $filter('number')(result, 2);
            }
            return $filter('number')(input, decimals);
        };
    }]);

})(angular.module('topline.filters'));